/**
 * markwell-reveal.js
 * Shared scroll-reveal (IntersectionObserver) + smooth-scroll.
 * Safe to load multiple times — guarded by window.__mwReveal.
 */
(function () {
  if (window.__mwReveal) return;
  window.__mwReveal = true;

  function init() {
    /* ── Scroll Reveal ── */
    var els = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
      els.forEach(function (el) { obs.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }

    /* ── Smooth Scroll ── */
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
